import { Injectable } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { DialogService } from '../dialogService/dialog-service';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {

  constructor(private deviceService: DeviceDetectorService, private dialogService: DialogService) { }
  /** Return device info to be used in device managament 
   * @returns Object (guid,name,os,version)
  */
  getDeviceInfo() {
    if (!localStorage.getItem("ui")) {
      localStorage.setItem("ui", Math.random().toString(16).slice(2));
    }
    return {
      guid: localStorage.getItem("ui"),
      name: this.getDeviceAlias().type,
      os: this.deviceService.browser,
      version: this.deviceService.browser_version
    }
  }

  /** Get user devices
  * @returns Promise
  */
  getDevices(requestService): void {
    let req = {
      url: "/api/device/getDevices"
    };
    requestService.mainGetRequest(req).then((resp: any) => {
      // Map options
      let options = resp.data.devices.map(obj => {
        return {
          id: obj.id,
          title: obj.name + " - v" + obj.version,
          icon: this.getIcon(obj)
        }
      });

      // Open dialog
      this.dialogService.openOptionsDialog({
        title: "gen_replace_device",
        message: "info_replace_device",
        options: options,
        confirm: "gen_replace",
        cancel: "gen_cancel"
      }).subscribe(resp => {
        // Delete device
        if (resp) {
          this.replaceDevice(resp.id, requestService);
        }
      });
    });
  }

  /** Replace a device
  * @returns Promise
  */
  replaceDevice(deviceId, requestService): Promise<any> {
    let req = {
      url: "/api/device/deleteDevice",
      req: {
        deviceId: deviceId
      }
    };
    return requestService.mainPostRequest(req);
  }

  /** Check Browser and return proper alias info
   * @returns Object (alias,type,videoFormat)
    */
  getDeviceAlias() {
    switch (this.deviceService.browser) {
      case "Firefox":
        return {
          alias: "BrowserFirefox",
          type: "Firefox",
          videoFormat: 1
        }
        break;
      case "Chrome":
        return {
          alias: "BrowserChrome",
          type: "Chrome",
          videoFormat: 1
        }
        break;
      case "MS-Edge-Chromium":
        return {
          alias: "BrowserEdge",
          type: "Edge",
          videoFormat: 1
        }
        break;
      case "Opera":
        return {
          alias: "BrowserOpera",
          type: "Opera",
          videoFormat: 1
        }
        break;
      case "Safari":
        return {
          alias: "BrowserSafari",
          type: "Safari",
          videoFormat: 0
        }
        break;
      default:
        return {
          alias: "Browser",
          type: "Web",
          videoFormat: 1
        }
        break;
    }
  }

  /** Get the proper device icon for a device  */
  getIcon(device) {
    let icon = "fas fa-question";
    switch (device.type) {
      case 1:
      case 2:
      case 3:
        icon = "fab fa-android";
        break;
      case 4:
      case 5:
        icon = "fab fa-apple";
        break;
      case 6:
        icon = "fab fa-chrome";
        break;
      case 7:
        icon = "fab fa-safari";
        break;
      case 8:
        icon = "fab fa-firefox";
        break;
      case 9:
        icon = "fab fa-edge";
        break;
      case 10:
      case 11:
        icon = "fas fa-tv";
        break;
      case 12:
        icon = "fab fa-opera";
        break;
      case 13:
        icon = "fas fa-laptop";
        break;
    }
    return icon;
  }
}
